import store from '@/store'

/**
 * Liste des champs qui supportent :
 * - Le `all` selector
 * - Le `IN` selector
 * - Le `NULL` selector
 * @type {string[]}
 */
const ALL_OR_MULTIPLE_OR_NULL_FIELDS = [
  'agent',
  'customer',
  'site'
]

/**
 * Converti les information d'un LwfFilter vers un format api
 * @param dateRange
 * @param isOptions
 * @param filters
 */
export const computeFilters = ({ dateRange, isOptions = {}, ...filters }) => {
  const _f = { ...filters, ...isOptions }
  ALL_OR_MULTIPLE_OR_NULL_FIELDS.forEach((k) => {
    const _k = k + 's'
    const _uK = 'is' + _.upperFirst(k)
    if (_f[_k] === undefined || (Array.isArray(_f[_k]) && _f[_k].length === 0)) { // All
      _f[_uK] = _f[_uK] === undefined ? -1 : _f[_uK]
      delete _f[_k]
    } else if (_f[_k] === null) {
      _f[_uK] = 0
      delete _f[_k]
    } else if (Array.isArray(_f[_k]) && _f[_k].length > 0) {
      _f[_uK] = 1
    }
  })
  if (dateRange) {
    const [start, end] = dateRange || []
    _f.start = start
    _f.end = end
  }
  return _f
}

/**
 * Génère une fonction avec les filtres d'API générique
 * @param requestFct
 * @param optDefault
 * @returns {function(?{filters?: *, ...opt}): *}
 */
export const createRequestWithComputedFilters = (requestFct, optDefault = {}) =>
  async (opt = {}) => {
    const params = _.merge({}, optDefault, opt)
    params.filters = params.filters ? computeFilters(params.filters) : {}
    return requestFct(params)
  }

/**
 * Génère le préfix agence
 */
export const agencyPath = () => `/agency/${store.getters['user/agencySlug']}`

/**
 * Génère le préfix agence
 */
export const agentPath = () => store.getters['user/isAgent']
  ? `/agent/${store.getters['user/agentSlug']}`
  : ''

/**
 * Génère le préfix customer si necessaire
 */
export const customerPath = () => store.getters['user/isCustomer']
  ? `/customer/${store.getters['user/customerSlug']}`
  : ''
